document.addEventListener('DOMContentLoaded', function() {
    // Selecting accordion heads
    let AcHead = document.querySelectorAll(".accordion .head");

    // Adding a click event listener to the accordion head element
    AcHead.forEach(function(head) {
        head.addEventListener('click', function() {
            let parent = this.parentNode;

            // Toggling the open class and setting the height of the dropdown accordingly
            if (parent.classList.contains("open")) {
                parent.classList.remove("open");
                parent.style.setProperty("--h", 0);
            } else {
                parent.classList.add("open");
                parent.style.setProperty("--h", parent.querySelector(".body").offsetHeight + "px");
            }
        });
    });
});
